import React, { useEffect, useState } from 'react';
import { Constants } from '../lib/const/constants';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { encryptPayload } from '../utils/encryption';
import { ArrowRight } from 'lucide-react';

function BeneficiaryOtpScreen() {
  const navigate = useNavigate();
  const location = useLocation();
  const paramsdata = location.state;
  const {
    currency,
    transferflowamount,
    currencyid,
    balance,
    beneId,
    routeName,
    nodeType,
    from_currency
  } = paramsdata;

  const [otp, setOtp] = useState(Array(6).fill(''));
  const [count, setCount] = useState(60);
  const [loading, setLoading] = useState(false);
  const Nav_node = paramsdata.Nav_node;
  const node = paramsdata?.node;
  const workspaces = JSON.parse(sessionStorage.getItem('login_workspaces'));
  const account_type = workspaces?.[0]?.type;
  const sendmoneynode = location.state?.sendmoneynode;

  const buyAmount = location.state?.buyAmount;
  const exchangeRate = location.state?.exchangeRate;
  const contactId =
    location.state?.sendmoney_contactId ?? location.state?.contactId;

  const receiveCurrencyValue = location.state?.currency;
  const receiveCurrency = location.state?.currencyid;

  const amount = location.state?.from_amount;
  const sendmoney_Nav_node = location.state?.sendmoney_Nav_node;

  const transfer_fee = location.state?.transfer_fee;
  const service_fee = location.state?.service_fee;
  const total_amount = location.state?.total_amount;

  const [balances, setBalances] = useState([]);
  const [usedBalances, setusedBalances] = useState([]);
  const previousPage = location.state?.previousPage;
  console.log('location',location);
  console.log('previousPage',previousPage);

  useEffect(() => {
    getBalances();
  }, []);

  const getBalances = async () => {
    const login_workspaces_id = sessionStorage.getItem('login_workspaces_id');
    const login_token = sessionStorage.getItem('login_token');
    try {
      const resp = await axios.get(
        Constants.BASE_URL +
          'API-FX-231-GET-WALLET-BALANCES/' +
          login_workspaces_id,
        {
          headers: {
            Authorization: 'Bearer ' + JSON.parse(login_token),
            fx_key: Constants.SUBSCRIPTION_KEY,
          },
        },
      );
      const balArray = Object.values(resp.data);
      setusedBalances(resp.data.used_balances);
      balArray.pop();
      balArray.pop();
      balArray.pop();
      balArray.pop();
      if (balArray.length > 0) {
        setBalances(balArray);
      }
    } catch (err) {
      console.log(err.response?.data || err);
    }
  };

  const getAvailableBalance = (currencyCode) => {
    const balanceObj = balances.find((b) => b.currency === currencyCode);
    if (!balanceObj) return 0;
    const used = usedBalances[currencyCode] || 0;
    const available = parseFloat(balanceObj.balance) - parseFloat(used);
    return available < 0 ? 0 : available;
  };

  useEffect(() => {
    if (count === 0) return;
    const interval = setInterval(() => setCount((c) => c - 1), 1000);
    return () => clearInterval(interval);
  }, [count]);

  const handleChange = (e, index) => {
    const val = e.target.value.replace(/[^0-9]/g, '');
    const newOtp = [...otp];
    newOtp[index] = val;
    setOtp(newOtp);

    if (val && index < 5) {
      document.getElementById(`otp-${index + 1}`).focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (/^[0-9]$/.test(e.key)) {
      e.preventDefault()
      const newOtp = [...otp];
      newOtp[index] = e.key;
      setOtp(newOtp);
      if (index < 5) {
        document.getElementById(`otp-${index + 1}`)?.focus();
      }
      return;
    }
    
    if (e.key === 'ArrowUp') {
      e.preventDefault();
      setOtp((prev) => {
        const newOtp = [...prev];
        const current = prev[index] || '0';
        newOtp[index] =
          current === '9' ? '0' : String((Number(current) + 1) % 10);
        return newOtp;
      });
    }
    if (e.key === 'ArrowDown') {
      e.preventDefault();
      setOtp((prev) => {
        const newOtp = [...prev];
        const current = prev[index] || '0';
        newOtp[index] =
          current === '0' ? '9' : String((Number(current) - 1 + 10) % 10);
        return newOtp;
      });
    }

    if (e.key === 'Backspace') {
       e.preventDefault()
      if(!otp[index]){
        if(index > 0){
          setOtp((prev)=>{
            const newOtp = [...prev]
            newOtp[index - 1] = ''
            return newOtp
          })
          document.getElementById(`otp-${index - 1}`)?.focus();
        }
      }
      else{
        setOtp((prev)=>{
          const newOtp = [...prev]
          newOtp[index] = ''
          return newOtp
        })
      }
    }
  };

  const login_email = sessionStorage.getItem('login_email');

  const otpValidate = async () => {
    setLoading(true);
    const enteredOtp = otp.join('');
    const token = sessionStorage.getItem('login_token');

    try {
      const url =
        Constants.BASE_URL + 'API-FX-144-beneficiaryverification/' + beneId;
        const encryptedPayload = await encryptPayload({ code: enteredOtp,platform: 'web',
          extraParamValidation: 'trustedfromweb' });
      const resp = await axios.post(
        url,
        encryptedPayload,
        {
          headers: {
            Authorization: 'Bearer ' + JSON.parse(token),
            fx_key: Constants.SUBSCRIPTION_KEY,
          },
        },
      );

      if (resp.data.code !== 400) {
        if (resp.data.message === 'Beneficiary OTP Verified.') {
          toast.success('OTP Verified Successfully');
          if (nodeType === 'SendMoneyCurrency') {
            navigate('/SendMoneyCurrency', {
              state: { currency, transferflowamount, currencyid, balance },
            });
          } else if (sendmoneynode || sendmoney_Nav_node === 2) {
            navigate('/Choosepayment', {
              state: {
                sendmoneycurrency: receiveCurrencyValue,
                currencyid: receiveCurrency,
                balance: receiveCurrencyValue
                  ? getAvailableBalance(receiveCurrencyValue).toLocaleString()
                  : '-',
                buyAmount: buyAmount,
                exchangeRate: exchangeRate,
                contactId: contactId,
                from_currency: from_currency,
                currency:currency,
                from_amount: amount,
                sendmoney_Nav_node: 2,
                transfer_fee:transfer_fee,
                service_fee:service_fee,
                total_amount:total_amount
              },
            });
          } else if (!routeName && account_type == 'business')
            navigate('/SendMoney', {
              state: {
                currency,
                transferflowamount,
                currencyid,
                balance,
                Nav_node: Nav_node,
              },
            });
          else if (!routeName && account_type == 'individual')
            navigate('/ListBeneficiaries', {
              state: {
                currency,
                transferflowamount,
                currencyid,
                balance,
                Nav_node: Nav_node,
              },
            });
          else
            navigate('/' + routeName, {
              state: { currency, transferflowamount, currencyid, balance },
            });
        } else {
          toast.error('Invalid OTP');
        }
      } else {
        toast.error(resp.data.message);
        navigate('/', { state: { qr_login_completed: 1 } });
      }
    } catch (err) {
      console.error(err.response?.data);
      toast.error('Invalid OTP');
    } finally {
      setLoading(false);
    }
  };

  const handleResendOtp = async () => {
    const token = sessionStorage.getItem('login_token');
    try {
      const resp = await axios.post(
        Constants.BASE_URL + 'API-FX-145-ResendbeneficiaryOTP/'+beneId,
        { beneficiary_id: beneId },
        {
          headers: {
            Authorization: 'Bearer ' + JSON.parse(token),
            fx_key: Constants.SUBSCRIPTION_KEY,
          },
        },
      );

      if (resp.data.status === 200) {
        toast.success('OTP resent successfully');
        setCount(60);
      } else {
        toast.success(resp.data.message || 'Failed to resend OTP');
      }
    } catch (err) {
      console.error(err);
      toast.error('Something went wrong. Please try again.');
    }
  };

  const handleCancel = () => {
    navigate(previousPage || '/BeneficiaryTypes', {
      state: {
        currency,
        currencyid,
        transferflowamount,
        balance,
        routeName,
        nodeType,
        buyAmount,
        exchangeRate,
        contactId,
        from_currency: from_currency,
        from_amount: amount,
        sendmoney_Nav_node,
        node,
      },
    });
  };

  return (
    <div
      className="flex flex-col items-center w-full"
      style={{
        minHeight: '100vh',
        padding: '32px 16px 40px',
        boxSizing: 'border-box',
        backgroundColor: '#ffffff',
        backgroundImage: 'linear-gradient(to bottom, #f8fafc 0%, #eff6ff4d 50%, #eef2ff66 100%)',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
      }}
    >
      <ToastContainer />

      {/* Page Title */}
      <h1
        style={{
          fontWeight: 700,
          fontSize: '24px',
          lineHeight: '150%',
          color: '#394784',
          marginBottom: '4px',
        }}
      >
        OTP Verification
      </h1>
      <p
        style={{
          fontWeight: 400,
          fontSize: '16px',
          lineHeight: '140%',
          color: '#676F7D',
          marginBottom: '24px',
        }}
      >
        Enter the OTP to add new beneficiary
      </p>

      <div style={{ width: '100%', maxWidth: '540px', padding: '0 16px', boxSizing: 'border-box' }}>


        <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '12px' }}>
          <button
            onClick={handleCancel}
            style={{
              background: '#FFFFFF',
              color: '#676F7D',
              fontWeight: 600,
              fontSize: '14px',
              border: '1px solid #E6E5E5',
              borderRadius: '8px',
              padding: '8px 20px',
              cursor: 'pointer',
            }}
          >
            Cancel
          </button>
        </div>

        {/* Card */}
        <div
          style={{
            width:'540px',
            borderRadius: '16px',
            border: '1px solid #F2F2F2',
            background: '#FFFFFF',
            padding: '32px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '16px',
            boxSizing: 'border-box',
            boxShadow: '0px 4px 16px -4px rgba(0,0,0,0.06)',
          }}
        >
          {/* Envelope image */}
          <img
            src="./otp-envelope.png"
            alt="otp"
            style={{ width: '96px', height: '77px', objectFit: 'contain' }}
            onError={(e) => { e.target.src = './password-lock.png'; }}
          />

          {/* Email label */}
          <div style={{ textAlign: 'center' }}>
            <p
              style={{
                fontWeight: 400,
                fontSize: '14px',
                color: '#676F7D',
                marginBottom: '4px',
              }}
            >
              Enter the OTP Sent to
            </p>
            <span
              style={{
                fontWeight: 600,
                fontSize: '16px',
                color: '#203358',
                textDecoration: 'underline',
              }}
            >
              {login_email}
            </span>
          </div>

          {/* OTP Inputs */}
          <div style={{ display: 'flex', justifyContent: 'center', gap: '16px' }}>
            {otp.map((digit, index) => (
              <input
                key={index}
                id={`otp-${index}`}
                type="text"
                inputMode="numeric"
                maxLength={1}
                value={digit}
                onChange={(e) => handleChange(e, index)}
                onKeyDown={(e) => handleKeyDown(e, index)}
                style={{
                  width: '44px',
                  height: '44px',
                  textAlign: 'center',
                  fontSize: '16px',
                  fontWeight: 700,
                  color: digit !== '' ? '#203358' : '#e6e5e5',
                  background: 'transparent',
                  outline: 'none',
                  border: 'none',
                  borderBottom: `2px solid ${digit !== '' ? '#203358' : '#E6E5E5'}`,
                  boxSizing: 'border-box',
                }}
              />
            ))}
          </div>

          {/* Resend */}
          <div
            style={{
              fontSize: '14px',
              color: '#707070',
              textAlign: 'center',
              fontWeight: 400,
              lineHeight: '100%',
              letterSpacing: '0%',
            }}
          >
            Did not receive the code?

            <div style={{ marginTop: '10px' }}>
              {count > 0 ? (
                <>
                  <span
                    style={{
                      color: '#306ACE',
                      fontWeight: 600,
                      fontSize: '14px',
                      lineHeight: '100%',
                      letterSpacing: '0%',
                      cursor: 'not-allowed',
                    }}
                  >
                    Resend OTP
                  </span>{' '}
                  <span
                    style={{
                      color: '#676F7D',
                      fontSize: '14px',
                      lineHeight: '100%',
                      letterSpacing: '0%',
                    }}
                  >
                    In {count} Sec
                  </span>
                </>
              ) : (
                <span
                  onClick={handleResendOtp}
                  style={{
                    color: '#306ACE',
                    fontWeight: 600,
                    fontSize: '14px',
                    lineHeight: '100%',
                    letterSpacing: '0%',
                    cursor: 'pointer',
                  }}
                >
                  Resend OTP
                </span>
              )}
            </div>
          </div>
        </div>

        {/* Verify OTP + Cancel Buttons */}
        <div style={{ marginTop: '24px', display: 'flex', gap: '12px' }}>
          {loading ? (
            <div style={{ textAlign: 'center', color: '#0B214E', fontWeight: 600, padding: '16px 0', flex: 1 }}>
              Processing...
            </div>
          ) : (
            <>
              <button
                onClick={otpValidate}
                style={{
                  flex: 1,
                  height: '56px',
                  paddingTop: '12px',
                  paddingRight: '20px',
                  paddingBottom: '12px',
                  paddingLeft: '20px',
                  borderRadius: '12px',
                  background: '#D26521',
                  color: '#FFFFFF',
                  fontWeight: 700,
                  fontSize: '16px',
                  border: 'none',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '16px',
                  boxSizing: 'border-box',
                  boxShadow: '0px 8px 20px 0px #0000001F',
                }}
              >
                <span>Verify OTP</span>
                <ArrowRight className='w-5 h-5 -ml-2.5' />
              </button>
            </>
          )}
        </div>

      </div>
    </div>
  );
}

export default BeneficiaryOtpScreen;